import path from 'node:path'
import type { DatabaseScaffoldOptions } from '@cli-types/next-adapter/init.js'
import { safeWriteFile } from '@cli-utils/files.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { readTemplate } from '@next-adapter/template-reader/read-template.js'

export function scaffoldDatabase({ cwd, config }: DatabaseScaffoldOptions): string[] {
  const created: string[] = []
  const dbDir = path.resolve(cwd, config.paths.admin, 'lib', 'db')
  const namespace = config.frameworkConfig.next.namespace

  function write(filename: string, content: string): void {
    const fullPath = path.join(dbDir, filename)
    if (safeWriteFile(fullPath, applyAdminNamespaceToContent(content, namespace))) {
      created.push(path.join(config.paths.admin, 'lib', 'db', filename))
    }
  }

  write('client.ts', readTemplate('lib/db/client.ts'))
  write('core/schema.ts', readTemplate('lib/db/core/schema.ts'))
  write('schema.ts', readTemplate('lib/db/schema.ts'))

  // Drizzle config goes at project root (where drizzle-kit expects it)
  const drizzleConfigPath = path.resolve(cwd, 'drizzle.config.ts')
  if (
    safeWriteFile(
      drizzleConfigPath,
      applyAdminNamespaceToContent(readTemplate('drizzle.config.ts'), namespace)
    )
  ) {
    created.push('drizzle.config.ts')
  }

  return created
}
